import React from 'react';
import styles from 'legacy_css_modules/NotificationLogo.module.css';
import logo from 'assets/png/logo_dark.png';

export const NotificationLogo = ({user, notifications, display, showNotifications, setShowNotifications }) => {
    
    const safeNotifications = Array.isArray(notifications) ? notifications : [];
    
    const unreadCount = safeNotifications.filter(n => !n.is_read).length;
    let totalCount = safeNotifications.length;

    const displayCount = unreadCount > 0 ? unreadCount : totalCount;
    const isGray = unreadCount === 0;

    const badgeText = displayCount > 9 ? '9+' : displayCount;

    
    if (display===false){
        totalCount=0
    }
    return (
        <div className={styles.container}>
            <div
                className={`${styles.logoWrapper} ${showNotifications ? styles.active : ''}`}
                onClick={() => display ? setShowNotifications(!showNotifications):null}
            >
                <img src={logo} alt="logo" className={styles.logo} />
                {totalCount > 0 && (
                    <span className={`${styles.badge} ${isGray ? styles.gray : ''}`}>
                        {badgeText}
                    </span>
                )}
            </div>
        </div>
    );
};
